import { Box, Button, styled } from "@mui/material";
import {
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  BUTTON_TEXT_COLOR,
  FONT_FAMILY,
  NAVBAR_ACTIVE_TEXT_COLOR,
  NAVBAR_AND_FOOTER_BACKGROUND_COLOR,
  NAVBAR_FOOTER_TEXT_COLOR,
  TEXT_COLOR,
} from "../../theme";

export const responsiveAppBarStyles = {
  appBar: {
    position: "fixed",
    top: "var(--guest-banner-height, 0px)",
    left: "0",
    width: "100%",
    height: "70px",
    backgroundColor: NAVBAR_AND_FOOTER_BACKGROUND_COLOR,
    zIndex: 100,
    color: "white",
    paddingTop: 0.6,
  } as const,
  loginButton: {
    width: "80%",
    textTransform: "none",
    marginY: 1,
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
    "&:hover": {
      borderColor: TEXT_COLOR,
    },
  } as const,
  signupButton: {
    marginLeft: "15px",
    fontSize: "15px",
    color: BUTTON_TEXT_COLOR,
    textTransform: "none",
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    borderRadius: "var(--radius-md, 8px)",
  } as const,
  userNameContainer: {
    height: 40,
    width: 90,
    backgroundColor: APP_COLOR,
    borderRadius: 1.5,
    marginY: -1.4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  userPageMintSong: {
    margin: 5,
    color: NAVBAR_ACTIVE_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 15,
    textDecoration: "none",
  } as const,
  userPageMintSongAndActive: {
    margin: 5,
    color: NAVBAR_ACTIVE_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 15,
    textDecoration: "none",
  } as const,
  userPageNotMintSong: {
    margin: 5,
    color: NAVBAR_FOOTER_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 15,
    textDecoration: "none",
  } as const,
  titleContainer: {
    display: "flex",
    alignItems: "center",
    margin: "5px",
  } as const,
  searchImage: {
    width: "50px",
    height: "50px",
    borderRadius: "10px",
    marginBottom: "10px",
  } as const,
  searchContainer: {
    display: "flex",
    padding: "10px 0px 10px 20px",
    alignContent: "center",
    "&:hover": {
      backgroundColor: "#3A4550",
      cursor: "pointer",
    },
  } as const,
  globalSearchBarContainer: {
    marginRight: "10px",
    display: "flex",
    justifyContent: "center",
  } as const,
  searchBarAfterMenuContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "20px",
    marginRight: "20px",
  } as const,
  autoComplete: {
    transition: "width 0.4s",
    height: "55px",
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
  } as const,
  inviteFriendsButton: {
    color: NAVBAR_FOOTER_TEXT_COLOR,
    fontFamily: FONT_FAMILY,
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "bold",
    marginRight: "20px",
    marginTop: "5px",
    padding: "2px 10px",
    boxShadow: "0px 10px 20px 2px rgba(1,1,1,0.5)",
    textDecoration: "underline",
  } as const,
  mediumScreenMenuIcon: {
    fontFamily: FONT_FAMILY,
    fontSize: 15,
    textDecoration: "none",
    backgroundColor: "inherit",
  } as const,
  hr: {
    marginBottom: 5,
    marginTop: 5,
  } as const,
  imageLogoContainer: {
    display: { xs: "flex", md: "none" },
    flexGrow: 1,
    ml: { xs: 0, md: 5 },
  } as const,
  mediumDisplayImageLogoContainer: {
    display: { xs: "none", md: "flex" },
    ml: { xs: 0, md: 5 },
    mr: 4,
  } as const,
  mediumDisplayUserPagesContainer: {
    flexGrow: 1,
    display: { xs: "none", md: "flex" },
    gap: "17px",
  } as const,
  userPagesContainer: {
    height: 40,
    width: 90,
    backgroundColor: APP_COLOR,
    borderRadius: 1.5,
    marginY: -1.4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  menu: {
    display: { xs: "block", md: "none" },
    mt: { xs: "4px", sm: "8px" },
  } as const,
  menuIconsButtonContainer: {
    flexGrow: 1,
    display: { xs: "flex", md: "none" },
  } as const,
  toolbarImageContainer: {
    display: "flex",
    flexGrow: 1,
    ml: { xs: 0, md: 5 },
  } as const,
  publicPageContainer: {
    display: "flex",
    gap: "20px",
    marginLeft: "30px",
    marginTop: "7px",
  } as const,
  publicPage: {
    "&:hover": {
      cursor: "pointer",
    },
  } as const,
  trackSearchBarTextField: {
    "& input": {
      color: NAVBAR_FOOTER_TEXT_COLOR,
    },
    position: "relative",
    marginRight: "10px",
    width: "320px",
    height: "35px",
  } as const,
  tracksSearchAutoComplete: {
    width: "100%",
    minWidth: "350px",
    "& .MuiOutlinedInput-root": {
      border: "none",
      "& fieldset": {
        border: `1px solid ${BORDER_COLOR}`,
      },
      "&.Mui-focused fieldset": {
        boxShadow:
          "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
      },
    },
  } as const,
};

export const SubscriptionContentContainer = styled(Box)(({ theme }) => ({
  height: "40px",
  display: "flex",
  alignItems: "center",
  marginLeft: "10px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const LoginButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  color: BUTTON_TEXT_COLOR,
  borderColor: BUTTON_TEXT_COLOR,
  "&:hover": {
    borderColor: BUTTON_TEXT_COLOR,
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const ExploresContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  marginLeft: "30px",
  marginTop: "7px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const SmallScreenBoxExplores = styled(Box)(({ theme }) => ({
  marginLeft: -15,
  marginRight: 25,
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

export const MenuUserSubscriptionContainer = styled(Box)(({ theme }) => ({
  color: "#90caf9",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

export const SearchBarBeforeMenu = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const SearchBarAfterMenu = styled(Box)(({ theme }) => ({
  display: "block",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

export const AccountMenuContainerForSmallScreen = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

export const AccountMenuContainerForBigScreen = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
